const API = process.env.REACT_APP_API_URL;

export const PK = 'PK';
export const INFO = 'INFO';
export const SERVICES = 'SERVICES';
export const CERTIFICATIONS = 'CERTIFICATIONS';
export const INSPECTIONS = 'INSPECTIONS';
export const OPERATING = 'OPERATING';
export const COMMUNICATIONS = 'COMMUNICATIONS';
export const INVOICES = 'INVOICES';
export const APPS = 'APPS';
export const SOLICITUDES = 'SOLICITUDES';
export const CONTACT = 'CONTACT';
export const USERS = 'USERS';
export const USERS_ADD = 'USERS_ADD';
export const USERS_DELETE = 'USERS_DELETE';
export const DELEGATIONS_ASSIGNATIONS = 'DELEGATIONS_ASSIGNATIONS';
export const DELEGATIONS_ASSIGNATIONS_ADD = 'DELEGATIONS_ASSIGNATIONS_ADD';
export const DELEGATIONS_ASSIGNATIONS_DELETE = 'DELEGATIONS_DELETE';
export const DELEGATIONS_ASSIGNATIONS_UPDATE = 'DELEGATIONS_UPDATE';
export const UPDATED_AT = 'UPDATED_AT';
export const SEND = 'SEND';
export const ALLOC_URL = 'ALLOC_URL';
export const DOWNLOAD_URL = 'DOWNLOAD_URL';

export const CONFIG = {
    api: [
        { key: PK, method: 'GET', endpoint: API + '/pk' },
        { key: INFO, method: 'GET', endpoint: API + '/info', updatedKey: 'datosPersonales' },
        { key: SERVICES, method: 'GET', endpoint: API + '/services', updatedKey: 'servicios' },
        { key: CERTIFICATIONS, method: 'GET', endpoint: API + '/certificates', updatedKey: 'certificados' },
        { key: INSPECTIONS, method: 'GET', endpoint: API + '/inspections', updatedKey: 'visitas' },
        { key: OPERATING, method: 'GET', endpoint: API + '/operating_data', updatedKey: 'datosExplotacion' },
        { key: COMMUNICATIONS, method: 'GET', endpoint: API + '/communications' },
        { key: INVOICES, method: 'GET', endpoint: API + '/invoices' },
        { key: APPS, method: 'GET', endpoint: API + '/apps' },
        { key: SOLICITUDES, method: 'GET', endpoint: API + '/mis_solicitudes', queryParam: 'pkOperador' },
        { key: CONTACT, method: 'GET', endpoint: API + '/contact' },
        { key: USERS, method: 'GET', endpoint: API + '/adm', path: 'operator' },
        { key: USERS_ADD, method: 'POST', endpoint: API + '/adm', path: 'operator' },
        { key: USERS_DELETE, method: 'DELETE', endpoint: API + '/adm', path: 'operator' },
        { key: DELEGATIONS_ASSIGNATIONS, method: 'GET', endpoint: API + '/adm' },
        { key: DELEGATIONS_ASSIGNATIONS_ADD, method: 'POST', endpoint: API + '/adm' },
        { key: DELEGATIONS_ASSIGNATIONS_DELETE, method: 'DELETE', endpoint: API + '/adm' },
        { key: DELEGATIONS_ASSIGNATIONS_UPDATE, method: 'PUT', endpoint: API + '/adm' },
        { key: UPDATED_AT, method: 'GET', endpoint: API + '/date_updated' },
        { key: SEND, method: 'POST', endpoint: API + '/contact' },
        { key: ALLOC_URL, method: 'POST', endpoint: API + '/upload' },
        { key: DOWNLOAD_URL, method: 'POST', endpoint: API + '/download' },
    ],
    menu: {
        desktop: 'desktop'
    },
    storage: {
        admin: 'admin',
        cod: 'cod',
        pk: 'pk',
        updatedAt: 'updatedAt',
        business: 'business',
        impersonated: 'impersonated',
        pk_b: 'pk_b',
        cod_b: 'cod_b',
    }
}